'use client'; // Error components must be Client Components

import NotFound from '@/components/NotFound';
import { Button } from '@/components/ui/button';
import Container from '@/components/ui/container';
import { Link } from '@/i18n/routing';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('error');

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Container>
      <section className="h-full py-20 text-center">
        <NotFound title={t('wrong')} />
        <div className="mx-auto my-10 flex w-1/2 flex-wrap gap-4 lg:flex-nowrap">
          <Button rounded={'full'} variant={'Error'} onClick={() => reset()}>
            {t('try-again')}
          </Button>
          <Link href={'/'} className="w-full">
            <Button rounded={'full'}>{t('go-home')}</Button>
          </Link>
        </div>
      </section>
    </Container>
  );
}
